export const getLatestDate = (dates: string[]) => {
  const descSortedDates = [...dates].sort((a, b) => +new Date(b) - +new Date(a));

  return descSortedDates[0];
};
